import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";

export interface UseSitesOptions {
  enabled?: boolean;
}

export function useSites(options: UseSitesOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ["sites"],
    queryFn: () => api.sites.list(),
    enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
